var TrilliumLoadingComponent = (function ($) {

    var _loadingBoundClass = 'trillium-loading-bound';
    var _body = $('body');
    var _settings = {
        background: 'rgba(35, 31, 32, 0.5)',
        imageColor: '',
        imageAnimation: '',
        image: '<svg style="margin: auto; display: block; shape-rendering: auto;" width="120px" height="120px" viewBox="0 0 120 120" preserveAspectRatio="xMidYMid"><g><path fill-rule="evenodd" clip-rule="evenodd" fill="#057c92" d="M0.24,109.2c0-35.947,0.003-71.895-0.019-107.842 c0-0.833,0.078-1.146,1.06-1.145c41.866,0.032,83.731,0.032,125.597,0c0.982-0.001,1.061,0.313,1.06,1.145 c-0.021,35.948-0.018,71.895-0.018,107.842c-0.415,0.226-0.864,0.115-1.295,0.115c-41.697,0.006-83.394,0.006-125.091,0 C1.104,109.315,0.654,109.425,0.24,109.2z"/><path fill-rule="evenodd" clip-rule="evenodd" fill="#ffffff" d="M0.24,109.2c42.56,0,85.12,0,127.68,0 c-0.095,0.516-0.492,0.224-0.72,0.226c-3.6,0.021-7.2,0.015-10.8,0.015c-38.36,0-76.72,0.001-115.081-0.015 C0.969,109.425,0.506,109.703,0.24,109.2z"/><path fill-rule="evenodd" clip-rule="evenodd" fill="#ffffff" d="M98.252,74.915c-4.199,0-8.398-0.028-12.597,0.022 c-0.923,0.011-1.19-0.275-1.123-1.156c0.071-0.914,0.079-1.844-0.001-2.757c-0.093-1.063,0.213-1.429,1.362-1.417 c6.118,0.062,12.236-0.004,18.354,0.058c1.144,0.012,1.405-0.347,1.349-1.406c-0.102-1.899-0.962-3.256-2.617-4.133 c-1.253-0.665-2.614-1.057-4.009-1.134c-4.99-0.277-9.996-0.448-14.97,0.088c-3.378,0.365-4.625,1.798-5.001,5.215 c-0.368,3.345-0.364,6.709-0.018,10.055c0.268,2.587,1.792,4.189,4.272,4.899c1.588,0.455,3.226,0.614,4.861,0.644 c4.315,0.077,8.637,0.282,12.944-0.11c2.798-0.256,4.085-1.51,4.461-4.278c0.107-0.786,0.352-0.992,1.092-0.969 c1.518,0.048,3.039,0.034,4.558,0.007c0.613-0.012,0.819,0.203,0.855,0.827c0.227,3.901-1.625,6.952-5.217,8.47 c-2.966,1.253-6.115,1.507-9.276,1.55c-4.437,0.059-8.876,0.159-13.312-0.091c-1.281-0.072-2.538-0.284-3.773-0.618 c-4.718-1.276-7.305-4.479-7.841-9.212c-0.463-4.092-0.537-8.253,0.016-12.329c0.759-5.6,3.718-8.591,9.596-9.386 c6.345-0.857,12.799-0.905,19.132,0.016c7.28,1.059,10.301,4.895,10.638,12.471c0.051,1.158-0.034,2.322,0.041,3.478 c0.06,0.919-0.199,1.235-1.179,1.223C106.65,74.883,102.451,74.915,98.252,74.915z"/><path fill-rule="evenodd" clip-rule="evenodd" fill="#ffffff" d="M47.765,89.439c-2.845-0.11-5.977,0.248-9.067-0.334 c-5.767-1.087-8.861-4.143-9.536-9.949c-0.446-3.844-0.447-7.772,0-11.616c0.689-5.931,4.159-9.249,10.235-9.882 c5.931-0.617,11.894-0.537,17.837-0.035c1.756,0.147,3.432,0.727,4.978,1.615c3.262,1.876,5.24,6.166,4.58,9.861 c-0.075,0.419-0.25,0.525-0.621,0.524c-1.6-0.007-3.199-0.018-4.798,0.006c-0.545,0.008-0.708-0.236-0.652-0.725 c0.004-0.039-0.001-0.08,0-0.119c0.198-4.317-2.084-5.813-5.949-5.9c-4.315-0.1-8.637-0.091-12.953,0.008 c-4.078,0.093-6.086,2.095-6.336,6.129c-0.168,2.715-0.152,5.438-0.019,8.153c0.199,4.067,2.159,6.188,6.197,6.555 c4.504,0.409,9.026,0.418,13.533,0.025c3.827-0.333,5.495-2.19,5.506-5.993c0.002-0.837,0.227-1.109,1.069-1.07 c1.396,0.065,2.799,0.041,4.198,0.009c0.622-0.015,0.839,0.202,0.83,0.829c-0.024,1.56-0.019,3.117-0.404,4.645 c-1.091,4.32-4.24,6.161-8.308,6.854C54.753,89.596,51.386,89.393,47.765,89.439z"/> <path fill-rule="evenodd" clip-rule="evenodd" fill="#ffffff" d="M16.313,73.316c0-4.797,0.022-9.594-0.021-14.39 c-0.007-0.873,0.182-1.198,1.11-1.143c1.394,0.083,2.801,0.083,4.195,0c0.967-0.057,1.19,0.278,1.187,1.207 c-0.033,9.074-0.02,18.148-0.02,27.223c0,0.6-0.039,1.202,0.009,1.798c0.058,0.721-0.192,0.997-0.94,0.974 c-1.518-0.046-3.04-0.059-4.556,0.004c-0.83,0.034-0.983-0.295-0.979-1.042C16.327,83.07,16.313,78.193,16.313,73.316z"/> <path fill-rule="evenodd" clip-rule="evenodd" fill="#ffffff" d="M16.313,48.713c0-0.836,0.03-1.675-0.01-2.51 c-0.03-0.626,0.102-0.945,0.833-0.923c1.592,0.048,3.188,0.042,4.78,0.002c0.71-0.018,0.871,0.28,0.858,0.922 c-0.034,1.673-0.034,3.347,0,5.02c0.013,0.646-0.152,0.935-0.86,0.916c-1.592-0.042-3.188-0.047-4.78,0.002 c-0.733,0.023-0.863-0.295-0.833-0.921C16.343,50.388,16.313,49.55,16.313,48.713z"/></g></svg>'
    };

    var showFullScreenLoading = function (customSettings) {
        if ($.LoadingOverlay !== undefined) {

            if (!_body.hasClass(_loadingBoundClass)) {
                $.LoadingOverlay('show', validateSettings(customSettings));
                _body.addClass();
            }
        }
    };

    var hideFullScreenLoading = function () {
        if ($.LoadingOverlay !== undefined) {
            $.LoadingOverlay("hide");
            _body.removeClass(_loadingBoundClass);
        }
    };

    var showSingleComponentScreenLoading = function (component, customSettings) {
        if ($.LoadingOverlay !== undefined) {

            if (typeof component === 'string') { component = $(component); }

            if (!component.hasClass(_loadingBoundClass)) {
                component.addClass(_loadingBoundClass).LoadingOverlay('show', validateSettings(customSettings));
            }
        }
    };

    var hideSingleComponentScreenLoading = function (component) {
        if ($.LoadingOverlay !== undefined) {

            if (typeof component === 'string') { component = $(component); }

            component.removeClass(_loadingBoundClass).LoadingOverlay('hide');
        }
    };

    var hideAllLoadingComponents = function () {
        if ($.LoadingOverlay !== undefined) {
            $('.' + _loadingBoundClass).removeClass(_loadingBoundClass).LoadingOverlay("hide");
            hideFullScreenLoading();
        }
    };

    var validateSettings = function (settings) {
        var settingsToBeUsed = _settings;
        if (settings !== undefined && settings !== null && typeof settings === 'object') {
            if (settings.background !== undefined) {
                settingsToBeUsed.background = settings.background;
            }

            if (settings.imageColor !== undefined) {
                settingsToBeUsed.imageColor = settings.imageColor;
            }

            if (settings.image !== undefined) {
                settingsToBeUsed.image = settings.image;
            }

            if (settings.custom !== undefined) {
                settingsToBeUsed.custom = settings.custom;
            }
        }

        return settingsToBeUsed;
    };

    return {
        showFullScreenLoading: function (settings) {
            showFullScreenLoading(settings);
        },
        hideFullScreenLoading: function () {
            hideFullScreenLoading();
        },
        showSingleComponentScreenLoading: function (component, settings) {
            showSingleComponentScreenLoading(component, settings);
        },
        hideSingleComponentScreenLoading: function (component) {
            hideSingleComponentScreenLoading(component);
        },
        hideAllLoadingComponents: function () {
            hideAllLoadingComponents();
        }
    };

})(window.jQuery);

window.TrilliumLoadingComponent = TrilliumLoadingComponent;
